import { call, put, takeLatest } from "redux-saga/effects"

import { GET_CALL_SUMMARY } from "./actionTypes"

import {
    getCallSummarySuccess,
    getCallSummaryError,
} from "./actions"

import {
    genericGetRequest_2
} from "../../helpers/sf_backend_helper"

import { AppConfiguration } from "config"

function* onGetCallSummary(action) {
    try {
        let user = JSON.parse(localStorage.getItem("authUser")).user
        const response = yield call(
            genericGetRequest_2,
            `${AppConfiguration.BACKEND_URL}/api/v1/quote_call_ai/${action?.payload}`,
            {},
            {
                Authorization: user.token,
                "account-id": user.account_id,
            }
        )
        yield put(getCallSummarySuccess(response))
    } catch (error) {
        yield put(getCallSummaryError(error))
    }
}



function* CallSummarySaga() {
    yield takeLatest(GET_CALL_SUMMARY, onGetCallSummary)
}

export default CallSummarySaga

